import apiClient from "../api/client";

export const PaiementService = {
  // Paiements
  async getPaiements(params?: any) {
    const response = await apiClient.get("/paiements/", { params });
    return response;
  },

  async getPaiement(id: string) {
    const response = await apiClient.get(`/paiements/${id}/`);
    return response;
  },

  async createPaiement(data: any) {
    const response = await apiClient.post("/paiements/", data);
    return response;
  },

  async executerPaiement(id: string) {
    const response = await apiClient.post(`/paiements/${id}/executer/`);
    return response;
  },

  async genererFichierVirement(data: {
    paiement_ids: string[];
    format: string;
  }) {
    const response = await apiClient.post(
      "/paiements/generer_fichier_virement/",
      data
    );
    return response;
  },

  // Fichiers de virement
  async getFichiersVirement() {
    const response = await apiClient.get("/paiements/fichiers-virement/");
    return response;
  },

  async envoyerFichierBanque(id: string) {
    const response = await apiClient.post(
      `/paiements/fichiers-virement/${id}/envoyer_banque/`
    );
    return response;
  },

  // Reconciliation
  async getReconciliations() {
    const response = await apiClient.get("/paiements/reconciliations/");
    return response;
  },

  async importerReleve(file: File) {
    const formData = new FormData();
    formData.append("fichier", file);

    const response = await apiClient.post(
      "/paiements/reconciliations/importer_releve/",
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }
    );
    return response;
  },

  // Confirmation de virement
  async confirmerVirement(id: string, referenceBanque?: string) {
    const response = await apiClient.post(`/paiements/${id}/confirmer-virement/`, {
      reference_banque: referenceBanque || '',
    });
    return response;
  },

  // Comptes bancaires
  async getComptesBancaires() {
    const response = await apiClient.get("/paiements/comptes-bancaires/");
    return response;
  },

  async getComptesBancairesActifs() {
    const response = await apiClient.get("/paiements/comptes-bancaires/actifs/");
    return response;
  },

  async createCompteBancaire(data: any) {
    const response = await apiClient.post("/paiements/comptes-bancaires/", data);
    return response;
  },

  async updateCompteBancaire(id: string, data: any) {
    const response = await apiClient.put(`/paiements/comptes-bancaires/${id}/`, data);
    return response;
  },

  async deleteCompteBancaire(id: string) {
    const response = await apiClient.delete(`/paiements/comptes-bancaires/${id}/`);
    return response;
  },
};
